import { ReCaptchaVersion } from '../../types/WebsiteConfig';
import { Config } from '../Config';
import { Logger, LogLevel } from "../Logger";
import { IService, ServiceType } from "../ServiceManager";

class ReCaptchaService implements IService {
  Type: ServiceType = ServiceType.ReCaptcha;
  Id: string = 'recaptcha';

  private Ident = '[ReCaptchaService]';

  private PendingWaiter: ((response: string) => void) | null = null;

  constructor() {
    const win = window as any;

    win.pl_recaptcha_callback = () => {
      if (this.PendingWaiter !== null) {
        this.PendingWaiter(win.grecaptcha.getResponse());
        this.PendingWaiter = null;
      }
    }

    const elem = document.createElement('div');

    elem.id = 'prolist-recaptcha';

    elem.setAttribute('data-sitekey', Config.Website.Settings!.ReCaptcha.ReCaptchaSiteKey);
    elem.setAttribute('data-size', Config.Website.Settings!.ReCaptcha.ReCaptchaVersion === ReCaptchaVersion.V2Invisible ? 'invisible' : '');
    elem.setAttribute('data-callback', 'pl_recaptcha_callback');

    document.body.appendChild(elem);

    this.LoadLibrary().then(() => {
      Logger.Log(LogLevel.Info, this.Ident, 'Loaded ReCaptcha');
    }).catch((ex) => {
      Logger.Log(LogLevel.Error, this.Ident, 'Failed to load ReCaptcha', ex);
    });
  }

  LoadLibrary(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const win = window as any;

      if(win.grecaptcha !== undefined) {
        Logger.Log(LogLevel.Debug, this.Ident, 'ReCaptcha is already defined');

        resolve(true);
        return;
      }

      const scr = document.createElement('script');

      win.pl_recaptcha_loaded = () => {
        win.grecaptcha.render('prolist-recaptcha');

        resolve(true);
      }

      scr.onerror = () => {
        reject();
      }

      scr.async = true;
      scr.defer = true;

      document.head.appendChild(scr);

      scr.src = 'https://www.google.com/recaptcha/api.js?onload=pl_recaptcha_loaded';
    });
  }

  GetResponse(): Promise<string> {
    const win = window as any;

    return new Promise((resolve, reject) => {
      if (win.recaptcha === undefined) {
        Logger.Log(LogLevel.Error, this.Ident, 'Recaptcha is not defined');

        reject();
        return;
      }

      win.grecaptcha.execute().then(() => {
        
        this.PendingWaiter = (res: string) => {
          resolve(res);
        }

      }).catch((ex: any) => {
        Logger.Log(LogLevel.Error, this.Ident, 'Failed to execute recaptcha', ex);

        reject();
      });
    });
  }

  Reset(): void {
    const win = window as any;

    try {
      win.grecaptcha.reset()
    } catch (ex) {

    }
  }
}

export { ReCaptchaService }